<script setup lang="ts">
import type { PrivacyTermsStatementProps } from '.';

import contactFormLocale from '~/components/ContactFormModal/ContactFormModal.locale.json';

const props = withDefaults(defineProps<PrivacyTermsStatementProps>(), {
	class: '',
	textClass:
		'mt-3 flex cursor-default flex-wrap justify-start gap-[6px] text-center text-xs leading-normal text-primary-light-1',
	linkClass: 'underline decoration-primary-light-1 underline-offset-[6px]',
	messages: () => contactFormLocale
});

const { t } = useI18n({
	useScope: 'local',
	messages: props.messages
});

const emit = defineEmits<{
	(e: 'terms-click'): void;
	(e: 'privacy-click'): void;
}>();

function handleTermsClick() {
	props.onTermsClick?.();
	emit('terms-click');
}

function handlePrivacyClick() {
	props.onPrivacyClick?.();
	emit('privacy-click');
}
</script>

<template>
	<I18nT
		keypath="privacyPolicyStatement"
		scope="parent"
		tag="p"
		:class="[textClass, props.class]"
	>
		<template #termsOfUse>
			<NuxtLink
				to="/termos-de-uso"
				:class="linkClass"
				target="_blank"
				@click="handleTermsClick"
			>
				Termos de Uso
			</NuxtLink>
		</template>
		<template #privacyPolicy>
			<NuxtLink
				to="/politica-de-privacidade"
				:class="linkClass"
				target="_blank"
				@click="handlePrivacyClick"
			>
				Política de Privacidade
			</NuxtLink>
		</template>
	</I18nT>
</template>
